import { render } from "./VehicleSharing.vue?vue&type=template&id=5dca2afe"
import script from "./VehicleSharing.vue?vue&type=script&lang=js"
export * from "./VehicleSharing.vue?vue&type=script&lang=js"
script.render = render

export default script